module.exports = __webpack_public_path__ + "img/shexiang2.bf736d84.png";